export const HTTP_UNAVAILABLE_FOR_LEGAL_REASONS = 451;

type Listener = () => void;

let open = false;
const listeners = new Set<Listener>();

const emit = () => {
  listeners.forEach((listener) => listener());
};

export const openAgreement = (): void => {
  if (open) return;
  open = true;
  emit();
};

export const closeAgreement = (): void => {
  if (!open) return;
  open = false;
  emit();
};

export const subscribeAgreement = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const getAgreementOpen = (): boolean => open;
